import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";

const WorkItemTemplatesContext = createContext();

export default function WorkItemTemplatesProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();
  const [allWorkItemTemplates, setAllWorkItemTemplates] = useState([]);
  const [currentWorkItemTemplates, setCurrentWorkItemTemplates] = useState([]);

  const updateWorkItemTemplates = async () => {
    logger.debug(
      "WorkItemTemplatesProvider.updateWorkItemTemplates",
      `GET field/WITemplates`
    );
    try {
      const data = await auth.get(`field/WITemplates`);

      logger.debug(
        "WorkItemTemplatesProvider.updateWorkItemTemplates",
        `Retrieved data`
      );

      return data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
    } catch (error) {
      logger.debug(
        "WorkItemTemplatesProvider.updateWorkItemTemplates",
        `Failed to retrieve data: ${JSON.stringify(error)}`
      );

      return [];
    }
  };

  const getWorkItemTemplates = async (filterArray = []) => {
    let allTemplates = allWorkItemTemplates;
    if (allTemplates.length === 0) {
      allTemplates = await updateWorkItemTemplates();
      setAllWorkItemTemplates(allTemplates);
    }
    const currentTemplates = allTemplates.filter((template) =>
      filterArray.includes(template.ref)
    );
    setCurrentWorkItemTemplates(currentTemplates);
    return currentTemplates;
  };

  const getCurrentWorkItemTemplates = () => currentWorkItemTemplates;

  return (
    <WorkItemTemplatesContext.Provider
      value={{
        getWorkItemTemplates,
        getCurrentWorkItemTemplates,
      }}
    >
      {children}
    </WorkItemTemplatesContext.Provider>
  );
}

WorkItemTemplatesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useWorkItemTemplates = () => useContext(WorkItemTemplatesContext);
